const CardContainer = ({ children, className, ...props }) => {
  return (
    <a
      className={`aspect-[3/4] rounded-lg cursor-pointer ${className ?? ""}`}
      {...props}
    >
      {children}
    </a>
  );
};

export default CardContainer;
